import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { equals, list_type, string_type, record_type, option_type, class_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC__toDateTime, UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { Result_Bind, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { int32ToString, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { SaveStatus, LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import * as react from "react";
import { singleton as singleton_2, isEmpty, fold, ofArray, map, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { Result_toBool, decimalToTwoDecimals, optToStr, DateTimeExtensions_toDateHHmmss, Locale_get_FromSelectedLanguage } from "../../Utils.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { dotsLoading } from "../../ViewUtils.js";
import { warning, info, error } from "../../Components/Message/Message.js";
import { RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { toString as toString_1 } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { renderHeader, renderScrollableTable, renderCell, Elements_renderCell } from "../../Components/Table/Table.js";
import { toString as toString_2, op_Addition, fromParts } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { separateByThousands } from "../../Utilities/String.js";
import { success, secondary } from "../../Components/Panel/Panel.js";
import { ButtonKind, wrappedButton, ButtonProps, defaultProps } from "../../Components/Button/Button.js";
import { renderAsModalThenSaveState } from "../../Components/Modals/SaveState/SaveState.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { isNotNullOrWhitespace, InputType, lengthLTE } from "../../Validation/Common.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import "../../../src/Containers/MortgageValidation/View.scss";


export class MortgageValidation extends Record {
    constructor(ContractNr, Created, InvoiceeNr, Paid, ContractValue) {
        super();
        this.ContractNr = (ContractNr | 0);
        this.Created = Created;
        this.InvoiceeNr = InvoiceeNr;
        this.Paid = Paid;
        this.ContractValue = ContractValue;
    }
}

export function MortgageValidation$reflection() {
    return record_type("Containers.MortgageValidation.View.MortgageValidation", [], MortgageValidation, () => [["ContractNr", int32_type], ["Created", UTC$reflection()], ["InvoiceeNr", class_type("System.Int64")], ["Paid", option_type(int32_type)], ["ContractValue", option_type(class_type("System.Decimal"))]]);
}

export class MakeMortgageValidationDTO extends Record {
    constructor(Note, ContractNrs) {
        super();
        this.Note = Note;
        this.ContractNrs = ContractNrs;
    }
}

export function MakeMortgageValidationDTO$reflection() {
    return record_type("Containers.MortgageValidation.View.MakeMortgageValidationDTO", [], MakeMortgageValidationDTO, () => [["Note", string_type], ["ContractNrs", list_type(int32_type)]]);
}

function Api_loadMortgageValidation(clientNr) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/Mortgage/Validation/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(list_type(MortgageValidation$reflection()), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(list_type(MortgageValidation$reflection()), arg_1, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(list_type(MortgageValidation$reflection()), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

function Api_saveMortgageValidation(clientNr, dto) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/Data/Mortgage/Validation/%i/"))(clientNr)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(int32_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(int32_type, arg_1, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(MakeMortgageValidationDTO$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(dto));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

export class MortgageValidationProps extends Record {
    constructor(GlobalDependencies) {
        super();
        this.GlobalDependencies = GlobalDependencies;
    }
}

export function MortgageValidationProps$reflection() {
    return record_type("Containers.MortgageValidation.View.MortgageValidationProps", [], MortgageValidationProps, () => [["GlobalDependencies", GlobalDependencies$reflection()]]);
}

export const renderMortgageValidation = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const mortgageValidationLoadState = react.useState(new LoadState$2(0));
    const mortgageValidationSaveState = react.useState(new SaveStatus(0));
    const noteState = react.useState("");
    const confirmationModalOpenState = react.useState(false);
    const savedMortgageValidations = react.useState(empty());
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    const loadMortgageValidation = () => {
        mortgageValidationLoadState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(Api_loadMortgageValidation(props.GlobalDependencies.ClientNr), (_arg) => {
            const result = _arg;
            const arg = (result.tag === 0) ? (new LoadState$2(2, result.fields[0])) : (new LoadState$2(3, result.fields[0]));
            mortgageValidationLoadState[1](arg);
            return singleton.Zero();
        })));
    };
    react.useEffect(loadMortgageValidation, [props.GlobalDependencies]);
    const children_52 = toList(delay(() => {
        let children_4;
        return props.GlobalDependencies.IsAdminUser ? append(singleton_1((children_4 = [getTranslation("MortgageValidation.Heading")], react.createElement("h1", {}, ...children_4))), delay(() => {
            let children_11, children_9, children_17, children_15, children_21, children_28, children_26, children_34, children_32, children_38, inputRecord, LabelText, matchValue_7, children_50, children_48;
            const matchValue_1 = mortgageValidationLoadState[0];
            switch (matchValue_1.tag) {
                case 1: {
                    return singleton_1(dotsLoading);
                }
                case 3: {
                    return singleton_1(error(matchValue_1.fields[0].split("")));
                }
                case 2: {
                    const mortgageValidations_2 = matchValue_1.fields[0];
                    const rows = map((mv_1) => {
                        let href;
                        const contractNrStr = int32ToString(mv_1.ContractNr);
                        const children_2 = [(href = RouterModule_encodeParts(ofArray(["CustomerContract", "Invoicee", toString_1(mv_1.InvoiceeNr), "Subscriptions", contractNrStr]), 1), Elements_renderCell(react.createElement("a", {
                            href: href,
                        }, contractNrStr))), renderCell(DateTimeExtensions_toDateHHmmss(locale.ILocale, UTC__toDateTime(mv_1.Created))), renderCell(toString_1(mv_1.InvoiceeNr)), renderCell(optToStr(mv_1.Paid)), renderCell(decimalToTwoDecimals(defaultArg(mv_1.ContractValue, fromParts(0, 0, 0, false, 0))))];
                        return react.createElement("tr", {}, ...children_2);
                    }, mortgageValidations_2);
                    let summaryPanelHtml;
                    const patternInput = fold((acc, curr) => [op_Addition(acc[0], defaultArg(curr.ContractValue, fromParts(0, 0, 0, false, 1))), acc[1] + 1], [fromParts(0, 0, 0, false, 1), 0], mortgageValidations_2);
                    let panelBodyHtml;
                    let nrOfContractsStr;
                    const arg_4 = getTranslation("MortgageValidation.NrOfContracts");
                    nrOfContractsStr = toText(printf("%s:"))(arg_4);
                    let totalContractValueStr;
                    const arg_5 = getTranslation("MortgageValidation.TotalContractValue");
                    totalContractValueStr = toText(printf("%s:"))(arg_5);
                    const children_19 = [(children_11 = [react.createElement("span", {}, nrOfContractsStr), (children_9 = [int32ToString(patternInput[1])], react.createElement("span", {
                        className: "ml-2",
                    }, ...children_9))], react.createElement("div", {}, ...children_11)), (children_17 = [react.createElement("span", {}, totalContractValueStr), (children_15 = [separateByThousands(toString_2(patternInput[0]))], react.createElement("span", {
                        className: "ml-2",
                    }, ...children_15))], react.createElement("div", {}, ...children_17))];
                    panelBodyHtml = react.createElement("div", {}, ...children_19);
                    summaryPanelHtml = secondary((children_21 = [getTranslation("MortgageValidation.Summary")], react.createElement("h4", {
                        className: "m-0",
                    }, ...children_21)), panelBodyHtml, void 0);
                    let saveSummaryPanelHtml;
                    const matchValue_2 = savedMortgageValidations[0];
                    if (isEmpty(matchValue_2)) {
                        saveSummaryPanelHtml = react.createElement(react.Fragment, {});
                    }
                    else {
                        const patternInput_1 = fold((acc_1, curr_1) => [op_Addition(acc_1[0], defaultArg(curr_1.ContractValue, fromParts(0, 0, 0, false, 1))), acc_1[1] + 1], [fromParts(0, 0, 0, false, 1), 0], matchValue_2);
                        let panelBodyHtml_1;
                        let nrOfContractsStr_1;
                        const arg_6 = getTranslation("MortgageValidation.NrOfContracts");
                        nrOfContractsStr_1 = toText(printf("%s:"))(arg_6);
                        let totalContractValueStr_1;
                        const arg_7 = getTranslation("MortgageValidation.TotalContractValue");
                        totalContractValueStr_1 = toText(printf("%s:"))(arg_7);
                        const children_36 = [(children_28 = [react.createElement("span", {}, nrOfContractsStr_1), (children_26 = [int32ToString(patternInput_1[1])], react.createElement("span", {
                            className: "ml-2",
                        }, ...children_26))], react.createElement("div", {}, ...children_28)), (children_34 = [react.createElement("span", {}, totalContractValueStr_1), (children_32 = [separateByThousands(toString_2(patternInput_1[0]))], react.createElement("span", {
                            className: "ml-2",
                        }, ...children_32))], react.createElement("div", {}, ...children_34))];
                        panelBodyHtml_1 = react.createElement("div", {}, ...children_36);
                        saveSummaryPanelHtml = success((children_38 = [getTranslation("Common.Saved")], react.createElement("h4", {
                            className: "m-0",
                        }, ...children_38)), panelBodyHtml_1, void 0);
                    }
                    let confirmationModalHtml;
                    const matchValue_3 = confirmationModalOpenState[0];
                    if (matchValue_3) {
                        let bodyHtml;
                        const children_41 = [getTranslation("Common.AreYouSure")];
                        bodyHtml = react.createElement("div", {
                            className: "text-center",
                        }, ...children_41);
                        const cancelButtonProps = new ButtonProps(getTranslation("Common.Cancel"), defaultProps.Content, (_arg_3) => {
                            confirmationModalOpenState[1](false);
                        }, defaultProps.Disabled, "mortgage-validation-cancel-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
                        const acceptButtonProps = new ButtonProps(getTranslation("Common.Confirm"), defaultProps.Content, (_arg_4) => {
                            const mortgageValidations_1 = mortgageValidations_2;
                            mortgageValidationSaveState[1](new SaveStatus(1));
                            const contractNrs = map((mv) => mv.ContractNr, mortgageValidations_1);
                            startImmediate(singleton.Delay(() => singleton.Bind(Api_saveMortgageValidation(props.GlobalDependencies.ClientNr, new MakeMortgageValidationDTO(noteState[0], contractNrs)), (_arg_1) => {
                                const result_1 = _arg_1;
                                let arg_2;
                                if (result_1.tag === 0) {
                                    savedMortgageValidations[1](mortgageValidations_1);
                                    arg_2 = (new SaveStatus(2));
                                }
                                else {
                                    arg_2 = (new SaveStatus(3, result_1.fields[0]));
                                }
                                mortgageValidationSaveState[1](arg_2);
                                return singleton.Zero();
                            })));
                        }, defaultProps.Disabled, "mortgage-validation-accept-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon);
                        let saveStr;
                        const matchValue_4 = mortgageValidationSaveState[0];
                        switch (matchValue_4.tag) {
                            case 3:
                            case 1: {
                                saveStr = (getTranslation("Common.Saving") + "...");
                                break;
                            }
                            case 2: {
                                saveStr = getTranslation("Common.Saved");
                                break;
                            }
                            default: {
                                saveStr = (getTranslation("Common.Saving") + "...");
                            }
                        }
                        confirmationModalHtml = renderAsModalThenSaveState(true, new ModalSize(1), getTranslation("Common.Confirm"), bodyHtml, cancelButtonProps, acceptButtonProps, getTranslation("Common.Close"), (_arg_5) => {
                            loadMortgageValidation();
                            confirmationModalOpenState[1](false);
                        }, singleton_2([saveStr, mortgageValidationSaveState[0]]));
                    }
                    else {
                        confirmationModalHtml = react.createElement(react.Fragment, {});
                    }
                    const noteValidationFn = (str) => Result_Bind((str_2) => lengthLTE(getTranslation, 255, new InputType(2), str_2), isNotNullOrWhitespace(getTranslation, str));
                    let noteHtml;
                    if (isEmpty(rows)) {
                        noteHtml = react.createElement(react.Fragment, {});
                    }
                    else {
                        const children_44 = [render_1()((inputRecord = TextProps$1_GetDefault(), (LabelText = getTranslation("Common.Note"), new TextProps$1(noteState[0], inputRecord.Type, inputRecord.Classes, (e) => {
                            noteState[1](Browser_Types_Event__Event_get_Value(e));
                        }, inputRecord.Disabled, LabelText, "mortgage-validation-note", noteValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))))];
                        noteHtml = react.createElement("div", {
                            className: "mortgage-validation__note",
                        }, ...children_44);
                    }
                    const submitButtonHtml = isEmpty(rows) ? react.createElement(react.Fragment, {}) : wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("MortgageValidation.ApproveMortgage"), defaultProps.Content, (_arg_6) => {
                        confirmationModalOpenState[1](true);
                    }, (!Result_toBool(noteValidationFn(noteState[0]))) ? true : ((matchValue_7 = (mortgageValidationLoadState[0]), (matchValue_7.tag === 1) ? true : ((matchValue_7.tag === 3) ? true : ((matchValue_7.tag === 2) ? (isEmpty(matchValue_7.fields[0])) : true)))), "mortgage-validation-submit-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
                    return append(singleton_1((children_50 = [(children_48 = toList(delay(() => append(singleton_1(renderScrollableTable(map(renderHeader, ofArray(["ContractNr", "Created", "InvoiceeNr", "Paid", "ContractValue"])), rows, 10, "mortgage-validation-table", void 0)), delay(() => (isEmpty(rows) ? singleton_1(info(getTranslation("MortgageValidation.CouldNotFind").split(""))) : singleton_1(react.createElement(react.Fragment, {}))))))), react.createElement("div", {
                        className: "mortgage-validation__table",
                    }, ...children_48)), summaryPanelHtml, saveSummaryPanelHtml], react.createElement("div", {
                        className: "mortgage-validation__container",
                    }, ...children_50))), delay(() => append(singleton_1(noteHtml), delay(() => append(singleton_1(submitButtonHtml), delay(() => singleton_1(confirmationModalHtml)))))));
                }
                default: {
                    return singleton_1(react.createElement(react.Fragment, {}));
                }
            }
        })) : singleton_1(warning(getTranslation("Common.MissingPrivileges").split("")));
    }));
    return react.createElement("div", {
        className: "mortgage-validation",
    }, ...children_52);
}, void 0, uncurry(2, void 0), void 0, "renderMortgageValidation", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\MortgageValidation\\View.fs", 305);

